import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Save from './save';
import Edit from './Edit';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
          d="m12,21.7c-.3,0-.6-.2-.8-.4l-2.1-3.4-.1-.1h-2c-2,0-3.1,0-3.9-.8s-.8-1.9-.8-3.9v-6c0-2,0-3.1.8-3.9.8-.9,1.9-.9,3.9-.9h10c2,0,3.1,0,3.9.8s.8,1.9.8,3.9v6c0,2,0,3.1-.8,3.9s-1.9.9-3.9.9h-2.1l-2.1,3.4c-.2.3-.5.5-.8.5ZM7,3.8c-1.7,0-2.5,0-2.9.4-.3.3-.3,1.1-.3,2.9v6c0,1.7,0,2.5.4,2.9.4.4,1.1.4,2.9.4h2c.6,0,1.1.3,1.4.8l1.6,2.6,1.7-2.7c.3-.4.7-.7,1.2-.7h2c1.7,0,2.5,0,2.9-.4s.4-1.1.4-2.9v-6c0-1.7,0-2.5-.4-2.9s-1.1-.4-2.9-.4c0,0-10,0-10,0Z"
          stroke-width="0"
        />
      <path
        d="M11.9978 13.6C10.0271 13.6 8.24694 12.5895 7.56758 11.0862C7.39245 10.6994 7.56951 10.2482 7.96211 10.0757C8.35279 9.90317 8.81276 10.0776 8.98789 10.4643C9.42091 11.4255 10.6314 12.0701 11.9978 12.0701C13.37 12.0701 14.5806 11.4217 15.0117 10.4568C15.1849 10.07 15.6429 9.89559 16.0355 10.0643C16.4281 10.2349 16.6071 10.6861 16.4339 11.0729C15.7584 12.5838 13.9763 13.6 11.9978 13.6Z"
      />
    </svg>
    ),
  },
});
